













































































import { Vue, Prop, Component } from "vue-property-decorator";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import {
  Contract as IContract,
  LearningResourceInfo as ILearningResourceInfo
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import ListenerInRequestList from "@/components/orders/ListenerInRequestList.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import { isAllowEditDates } from "@/plugins/modules-detect";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import ImportedLearningRequestItem from "@/components/orders/ImportedLearningRequestItem.vue";
import ContractForm from "@/components/contract/ContractForm.vue";
import courses, { CourseListParams } from "@/getinfo-api/course";
import CustomTable from "@/components/form/CustomTable.vue";
import { bookkeepingModule } from "@/plugins/modules-detect";

@Component({
  components: {
    CustomTable,
    ContractForm,
    ImportedLearningRequestItem,
    CBlock,
    CustomDatepicker,
    CourseRegistrationsTable,
    ListenerInRequestList,
    Modal,
    CustomButton,
    CustomTableCol,
    CustomTableItem
  },
  computed: {
    isAllowToEditDates: isAllowEditDates
  }
})
export default class ImportedUsersOrders extends Vue {
  @Prop() requests!: ILearningRequest[];
  isOpenContractCreate: boolean = false;
  learningResources: ILearningResourceInfo[] = [];
  contracts: IContract[] = [];
  checkedRequests: ILearningRequest[] = [];

  data() {
    return {};
  }

  get bookkeepingModule() {
    return bookkeepingModule();
  }

  get contractor() {
    let request = this.checkedRequests.find(el => el.contractor);
    if (request) {
      return {
        contractorId: request.contractor?.id,
        contractorType: request.contractor?.type
      };
    }

    return { contractorId: null, contractorType: null };
  }

  saveContract(contract: IContract) {
    this.contracts = [...this.contracts, contract];
    this.isOpenContractCreate = false;
  }

  async createContract() {
    this.learningResources = [];
    const allSelectedCourse = this.checkedRequests
      ?.filter(
        el => el.resourceType === "course" || el.resourceType === "course2"
      )
      .map(el => el.resourceId);
    const uniqIds = new Set(allSelectedCourse);
    const uniqIdsArray = [...uniqIds];

    const params: CourseListParams = {
      ids: uniqIdsArray,
      limit: 30
    };

    try {
      let response = await courses(params);
      const detailCourses = response.data.courses;

      const getHoursByCourseId = (courseId: string): number => {
        const [course] = detailCourses?.filter(el => el.id === courseId);
        return course.hours ? course.hours : 0;
      };

      this.checkedRequests.forEach(el => {
        if (el) {
          this.learningResources.push({
            id: el.resourceId,
            type: el.resourceType,
            title: el.resourceTitle
              ? el.resourceTitle
              : this.$tc(this.$translate.NotSpecified),
            userIds: el.users.map(el => el.id),
            price: +(el.price / el.users.length).toFixed(0),
            creationMethod: 1,
            learningRequestId: el.id,
            amount: el.price,
            hours:
              el.resourceType === "course"
                ? getHoursByCourseId(el.resourceId)
                : 0
          });
        }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    }
    this.isOpenContractCreate = true;
  }
}
